// extracted by mini-css-extract-plugin
module.exports = {"writebox":"Writebox_writebox__18V7A","dark":"Writebox_dark__1PNHa","light":"Writebox_light__2-cWY","write":"Writebox_write__2sXhI"};